import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { Fragment } from 'react';

import cn from '@/lib/clsxm';

import ModalAction from '@/components/@base/modal/action';
import ModalBody from '@/components/@base/modal/body';
import ModalHead from '@/components/@base/modal/head';
import { Props } from '@/components/@base/modal/type';

export default function Modal({
  onClose,
  show = false,
  noBackDrop = false,
  children,
  dialogProps,
  className,
  dialogPanelProps,
  dialogPanelClassName,
}: Props) {
  const { className: dialogClassName, ...otherDialogProps } = dialogProps || {};
  const { className: otherDialogPanelClassName, ...otherDialogPanelProps } =
    dialogPanelProps || {};
  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog
        as='div'
        className={cn('relative z-100', dialogClassName, className)}
        onClose={() => onClose?.()}
        {...otherDialogProps}
      >
        {!noBackDrop && (
          <TransitionChild
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black/50' onClick={(e) => e.preventDefault()} />
          </TransitionChild>
        )}

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center px-2 py-4 text-center sm:p-4'>
            <TransitionChild
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 scale-95'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95'
            >
              <DialogPanel
                className={cn(
                  'w-full max-w-md overflow-hidden rounded-2xl bg-white p-4 text-left align-middle shadow-xl md:p-6',
                  otherDialogPanelClassName,
                  dialogPanelClassName,
                )}
                {...otherDialogPanelProps}
              >
                {children}
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export { ModalAction, ModalBody, ModalHead };
